import Vue from 'vue'
import $ from 'jquery'
import swal from "sweetalert2";
import axios from 'axios'
// var _ = require('lodash');

/**
 * Vue.prototype.$api
 */
const BaseApi = {
    currentFilter: {},
    credentials: null,
    onGetError: function (error, a, b, c) {
        console.error(error, a, b, c)
        Vue.prototype.$eventHub.$emit('OnError', error)

        Vue.prototype.$api.hideIdle()
    },
    /**
     * Vue.prototype.$api.getCredentials()
     * @returns {{fromURL: boolean, authorized: boolean, authToken: (*|string)}|*}
     */
    getCredentials() {
        // return Vue.prototype.$api.credentials
        if (!this.credentials) {
            this.checkCredentials()
        }
        return this.credentials
    },
    setCredentials(credits) {
        this.credentials = credits
        window.localStorage.cmCredentials = JSON.stringify(credits)
    },
    resetCredentials: function (cmp) {
        if (window.localStorage) {
            window.localStorage.credentials = null
            window.localStorage.cmCredentials = null
        }
        Vue.prototype.$eventHub.$emit('OnLogin', false)
        if (cmp) {
            cmp.$router.push('/Login')
        }
    },
    getAuthToken() {
        return Vue.prototype.$api.getCredentials().authToken
    },
    exportToExcel: function (data, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/kav/kstktr/exportToExcel?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
        // reqData.type = type
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.responseType = 'blob';

        xhr.send(JSON.stringify(data));

        xhr.onload = function (e) {

            if (this.status == 200) {
                fnOk(e)
                Vue.prototype.$api.hideIdle()
                // Create a new Blob object using the response data of the onload object
                var blob = new Blob([this.response], {type: 'image/pdf'});
                //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
                let a = document.createElement("a");
                a.style = "display: none";
                document.body.appendChild(a);
                //Create a DOMString representing the blob and point the link element towards it
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = 'export.xlsx';
                //programatically click the link to trigger the download
                a.click();
                //release the reference to the file by revoking the Object URL
                window.URL.revokeObjectURL(url);
            } else {
                cmp.onGetError(e, fnFailed)
            }
        };
    },
    getSystemLog: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/system/logs?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    linkPlayListToDevice: function (playlist, deviceGuid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/linkToDevice/' + playlist.guid + '/' + deviceGuid + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    linkPlayListToPlayList: function (deviceGuid, playlist, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun vom Server auf Ihr Reisebüro TV - Gerät übertragen.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/linkpl/' + playlist.guid + '/' + deviceGuid + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    getPlayListStats: function (guid, fnSuccess, fnError) {
        Vue.prototype.$api.showIdle()
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + guid + '/stats?time=' + new Date().getTime()
        axios({
            method: 'get',
            url: url,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnSuccess) {
                    fnSuccess(response.data)
                }
            }, function (error) {
                Vue.prototype.$api.hideIdle()
                Vue.prototype.$eventHub.$emit('OnShowError', error)
                if (fnError) {
                    fnError(error, status, error)
                } else {
                    console.error('error')
                    console.error(error)
                    console.log(status)
                }
            })
    },

    removeCloneLinkPlayListToCompany: function (guid, companyId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/removeClone/' + guid + '/company/' + companyId + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    unlinkPlayListFromCompany: function (guid, companyId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/unlink/' + guid + '/company/' + companyId + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },

    linkPlayListToCompany: function (playlist, company, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/link/' + playlist.guid + '/' + company.guid + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createCloneLinkPlayListToCompany: function (playlist, company, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/clone/' + playlist.guid + '/' + company.guid + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createPlayListToDevices: function (playlists, devices, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var reqData = {
            playlists: playlists,
            devices: devices
        }
        var url = Vue.prototype.$config.HOST + '/v1/playlists/createAndLinkDevices?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createPlayListToCompanies: function (playlists, companies, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var reqData = {
            playlists: playlists,
            companies: companies
        }
        var url = Vue.prototype.$config.HOST + '/v1/playlists/createAndLinkCompanies?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    linkPlayListToCompanies: function (playListGuid, companies, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var reqData = {
            guid: playListGuid,
            companies: companies
        }
        var url = Vue.prototype.$config.HOST + '/v1/playlists/linkCompanies?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    linkCompanyToCompany: function (guid, company, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/link/' + guid + '/' + company.guid + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    unlinkCompanyToCompany: function (guid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/unlink/' + guid + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    linkDeviceToCompany: function (guid, company, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/devices/link/' + guid + '/' + company.guid + '?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createPlaylist: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createPlaylistItem: function (guidPlaylist, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + guidPlaylist + '/items/create?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createPlaylistItemByMedia: function (guidPlaylist, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + guidPlaylist + '/items/createByMedia?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadPlayLists: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/playlists/list?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadChannels: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/channels/list?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    deletePlaylistItem: function (plId, itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/playlists/' + plId + '/items/' + itemId + '/delete?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    deletePlaylist: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '/delete?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadPlayListsFromCompany: function (companyGuid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/' + companyGuid + '/playlists?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadChannelsFromCompany: function (companyGuid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/' + companyGuid + '/channels?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadApps: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/apps/list?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadDevices: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/devices/list?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadDevicesWithMeta: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/devices/support'

        var params = reqData
        if (!params) {
            params = {}
        }
        params.token = Vue.prototype.$api.getCredentials().authToken
        params.time = new Date().getTime()

        axios({
            method: 'get',
            url: url,
            params: params,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    loadDevicesFromCompany: function (companyGuid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/' + companyGuid + '/devices?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    /**
     *
     * @param companyGuid
     * @param item
     * @param state
     * @param fnOk
     * @param fnFailed
     */
    setMediaStateFromCompany: function (companyGuid, item, state, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/media/' + companyGuid + '/item/active?time=' + new Date().getTime()
        var reqData = {
            'itemGuid': item.guid,
            'state': state,
            'update': true
        }
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    checkMediaStateFromCompany: function (companyGuid, item, state, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/media/' + companyGuid + '/item/active?time=' + new Date().getTime()
        var reqData = {
            'itemGuid': item.guid,
            'state': state,
            'update': false
        }
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadMediaAll: function (fnOk, fnFailed, gridParams) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/media/all?time=' + new Date().getTime()
        Vue.prototype.$api.showIdle()
        var reqData = {
            'gridParams': gridParams
        }
        axios({
            method: 'post',
            url: url,
            params: {
                token: Vue.prototype.$api.getCredentials().authToken,
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    loadMediaStatus: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/media/status?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    deleteMediaByStatus: function (items, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/media/status/deleteGlobal'
        var reqData = {
            'items': items
        }
        axios({
            method: 'post',
            url: url,
            params: {
                token: Vue.prototype.$api.getCredentials().authToken,
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    loadMediaFromCompany: function (companyGuid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/media/' + companyGuid + '/items?time=' + new Date().getTime()
        $.get(url, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    updateMail: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/mail/' + itemId
        axios({
            method: 'put',
            url: url,
            params: {
                token: Vue.prototype.$api.getCredentials().authToken,
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    createMail: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/mail'
        axios({
            method: 'post',
            url: url,
            params: {
                token: Vue.prototype.$api.getCredentials().authToken,
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    deleteMail: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.ajax({
            url: Vue.prototype.$config.HOST + '/v1/mail/' + itemId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken,
            type: 'DELETE',
            dataType: 'json',
            success: function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) fnOk(response)
            },
            error: function (errorResponse) {
                if (fnFailed) {
                    Vue.prototype.$api.hideIdle()
                    fnFailed(errorResponse)
                } else {
                    cmp.onGetError(errorResponse, fnFailed)
                }
            }
        });
    },
    getMails: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/mail?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    getMail: function (guid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/mail/' + guid

        axios({
            method: 'get',
            url: url,
            params: {
                token: Vue.prototype.$api.getCredentials().authToken,
                time: new Date().getTime()
            },
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    getMailsWithFilter: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.post(Vue.prototype.$config.HOST + '/v1/mail/search?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken,reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    sendMail: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/mail/send'

        axios({
            method: 'post',
            url: url,
            params: {
                token: Vue.prototype.$api.getCredentials().authToken,
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    createComment: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/comments?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    deleteComment: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.ajax({
            url: Vue.prototype.$config.HOST + '/v1/comments/' + itemId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken,
            type: 'DELETE',
            dataType: 'json',
            success: function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) fnOk(response)
            },
            error: function (errorResponse) {
                if (fnFailed) {
                    Vue.prototype.$api.hideIdle()
                    fnFailed(errorResponse)
                } else {
                    cmp.onGetError(errorResponse, fnFailed)
                }
            }
        });
    },
    getComments: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/comments?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    getCommentsWithFilter: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.post(Vue.prototype.$config.HOST + '/v1/comments/search?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken,reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },

    deleteDevice: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/devices/' + itemId + '/delete?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadPlayListItems: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '/items?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadPlayList: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadPlayListItem: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '/item?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadDevice: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/devices/' + itemId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadApp: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/apps/' + itemId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    updateApps: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/apps/' + itemId + '?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    savePlayListSort: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        // reqData = JSON.stringify(reqData)
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '/sort?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    getLocationsWherePlayListLinked: function (guidPlaylist, guidCompany,fnSuccess, fnError) {
        Vue.prototype.$api.showIdle()
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + guidPlaylist + '/locations/' + guidCompany + '?time=' + new Date().getTime()
        axios({
            method: 'get',
            url: url,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnSuccess) {
                    fnSuccess(response.data)
                }
            }, function (error) {
                Vue.prototype.$api.hideIdle()
                Vue.prototype.$eventHub.$emit('OnShowError', error)
                if (fnError) {
                    fnError(error, status, error)
                } else {
                    console.error('error')
                    console.error(error)
                    console.log(status)
                }
            })
    },
    sharePlayListToCompanies: function (ownerGuid, itemId, companies, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        let reqData = {
            owner: ownerGuid,
            companies: companies,
            plGuid: itemId
        }
        // reqData = JSON.stringify(reqData)
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '/share?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    updatePlayList: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        // reqData = JSON.stringify(reqData)
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    updatePlayListItem: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        // Playlist items also contain generated thumbnails and media metadata.
        // This legacy endpoint only persists the fields below; forwarding the
        // entire item can exceed Express' request limit when sorting.
        var updateData = {
            guid: reqData.guid,
            duration: reqData.duration,
            localFileName: reqData.localFileName,
            activeFrom: reqData.activeFrom,
            activeTill: reqData.activeTill,
            active: reqData.active,
            name: reqData.name,
            orderNr: reqData.orderNr
        }
        // reqData = JSON.stringify(reqData)
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '/item?time=' + new Date().getTime()

        $.post(url, updateData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    updatePlayListItemOrderNr: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        // reqData = JSON.stringify(reqData)
        var url = Vue.prototype.$config.HOST + '/v1/playlists/' + itemId + '/itemOrderNr?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    getVideoUrl: function (item) {
        var fileName = item.localFileName
        var lIndex = fileName.lastIndexOf('.')
        var ext = '.mp4' // fileName.substr(lIndex)
        fileName = fileName.substr(0, lIndex) + 'web' + ext
        console.log('getVideoUrl', item.localFileName, fileName)
        var url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + fileName
        return url
    },
    updateDeviceJSON: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/devices/JSON/' + itemId + '?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    initDragAndDrop(cmp, config, eventHub) {
        console.log('init drag and drop', cmp, config)
        config.eventHub = eventHub
        window.jQuery(config.jQueryDivName).dmUploader({
            url: function () {
                return config.uploadUrl
            },
            fileName: 'files',
            dataType: 'json',
            headers: {},
            allowedTypes: '*',
            /* extFilter: 'jpg;png;gif', */
            onInit: function () {
                console.log('onInit uploader')
            },
            onBeforeUpload: function (id) {
                // updateFileStatus(id, 'uploading', 'Uploading...')
                console.log(id)
                config.eventHub.$emit('lockScreen')
            },
            onNewFile: function (id, file) {
                config.eventHub.$emit('unlockScreen')
                console.log(id, file)
            },
            onComplete: function () {
                console.log('upload complete')
                config.eventHub.$emit('unlockScreen')
            },
            onUploadProgress: function (id, percent) {
                if (config.onUploadProgress) config.onUploadProgress(id, percent)
            },
            onUploadSuccess: function (id, data) {
                if (config.onUploadSuccess) config.onUploadSuccess(id, data)
                cmp.$eventHub.$emit('unlockScreen')
            },
            onUploadError: function (id, message) {
                cmp.$eventHub.$emit('unlockScreen')
                swal('Upload Fehler', id + ' - ' + message, 'error')
            },
            onFileTypeError: function (file) {
                console.log('file', file)
            },
            onFileSizeError: function (file) {
                console.log('file', file)
            },
            onFileExtError: function (file) {
                console.log('file', file)
            },
            onFallbackMode: function (message) {
                swal(
                    'Upload Fehler',
                    'Browser not supported(do something else here!): ' + message,
                    'error'
                )
            }
        })
    },
    updateDevice: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/devices/' + itemId + '?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    archiveDevice: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/devices/archive/' + itemId + '?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadPlayListByDeviceGuid: function (deviceGuid, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/api/playlist?key=' + deviceGuid + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createApp: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/apps?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadKostenartenSumme: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/kav/kstart/sum?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },

    loadKostenTraeger: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/kav/ksttraeger?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadVerteilungSummen: function (fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/kav/VerteilungSummen?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    showIdle: function (data) {
        if (!data) {
            data = true
        }
        Vue.prototype.$eventHub.$emit('OnShowIdle', data)
    },
    hideIdle: function () {
        Vue.prototype.$eventHub.$emit('OnShowIdle', false)
    },
    saveSystemConfig: function (name, data, fnOk, fnFailed) {
        // ('oracleConnection', this.oracleConnection, this.onGetData)
        var reqData = {
            text: JSON.stringify({
                name: name,
                data: data
            })
        }
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/system/config?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(this, error, a, b, c, fnFailed)
            }
        })
    },
    test: function (fnOk, fnFailed) {
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/kav/test?' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(this, error, a, b, c, fnFailed)
            }
        })
    },
    loadSystemConfig: function (fnOk, fnFailed) {
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/system/config?' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(this, error, a, b, c, fnFailed)
            }
        })
    },
    checkCredentials: function (cmp) {
        if (cmp && cmp.$route.query.authToken) {
            Vue.prototype.$api.credentials = {
                'authorized': true,
                'fromURL': true,
                'authToken': cmp.$route.query.authToken
            }
            return
        }
        if (Vue.prototype.$api.credentials && Vue.prototype.$api.credentials.authorized) {
            return Vue.prototype.$api.credentials
        } else {
            if (window.localStorage && window.localStorage.cmCredentials) {
                Vue.prototype.$api.credentials = JSON.parse(window.localStorage.cmCredentials)
                if (Vue.prototype.$api.credentials && Vue.prototype.$api.credentials.authorized) {
                    Vue.prototype.$eventHub.$emit('OnLogin', true)
                    return Vue.prototype.$api.credentials
                }
                return null
            }
        }
        // cmp.$router.push('/Login')
        return null
    }
}
export default BaseApi
